import { render, staticRenderFns } from "./Community.vue?vue&type=template&id=1cb77dbd&"
import script from "./Community.vue?vue&type=script&lang=ts&"
export * from "./Community.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports